import Vue from 'vue';
window.Vue = require('vue').default;

import './bootstrap';
import './plugins';
import FormError from './components/FormError.vue';
import SwalMessages from "./mixins/SwalMessages";
import ErrorsHandler from "./mixins/ErrorsHandler";
import DateConverter from "./mixins/DateConverter";
import StyleHandler from "./mixins/StyleHandler";
import ModalHandler from "./mixins/ModalHandler";
import PaginationHandler from "./mixins/PaginationHandler";
import SortDirectionHandler from "./mixins/SortDirectionHandler";
import ExportHandler from "./mixins/ExportHandler";

import vTitle from './plugins/VueTitle'
import moment from "moment/moment";
Vue.use(vTitle)


import { setupCalendar, Calendar, DatePicker } from 'v-calendar';
Vue.use(setupCalendar, {})

// Use the components
Vue.component('VCalendar', Calendar)
Vue.component('VDatePicker', DatePicker)


const mixins = [
    SwalMessages,
    ErrorsHandler,
    DateConverter,
    StyleHandler,
    ModalHandler,
    PaginationHandler,
    SortDirectionHandler,
    ExportHandler,
];
mixins.forEach(mixin => Vue.mixin(mixin));

Vue.filter('momentFromNow', function (value) {
    if (!value) return '';
    value = value.toString();
    return moment(value).fromNow();
});

Vue.filter('capitalizeFirst', function(value) {
    if (!value) return '';
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.component('FormError', FormError );

const files = require.context('./', true, /\.vue$/i);
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

const modulesFiles = require.context('../../app/Modules/', true, /\.vue$/i);
modulesFiles.keys().map(key => {
    Vue.component(key.split('/').pop().split('.')[0], modulesFiles(key).default)
});


const app = new Vue({
    el: '#app',
    methods: {
        load() {
            $('body').addClass('overlay-screen');
        },
        loaded() {
            $('body').removeClass('overlay-screen');
        },
    }
});
